// extracted by mini-css-extract-plugin
export var lgBreak = "1200";
export var mdBreak = "992";
export var smBreak = "768";
export var taxTool = "TaxTool-module--taxTool--93bfc";
export var taxTool_heading_and_input = "TaxTool-module--taxTool_heading_and_input--c4c91";
export var taxTool_information = "TaxTool-module--taxTool_information--0072e";
export var taxTool_left_align = "TaxTool-module--taxTool_left_align--d70ca";
export var taxTool_subheading_and_input = "TaxTool-module--taxTool_subheading_and_input--adc7c";
export var taxTool_triangle = "TaxTool-module--taxTool_triangle--5cca4";
export var xsBreak = "480";